import { SvgIcon } from '@mui/material';
import { memo } from 'react';

function SvgComponent({ className = '', ...rest }) {
  return (
    <SvgIcon viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' className={className} {...rest}>
      <rect y='0.5' width='24' height='24' rx='4' fill='none' stroke='none' />
      <path
        d='M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8'
        fill='currentColor'
      />
    </SvgIcon>
  );
}

const ReplayIcon = memo(SvgComponent);
export default ReplayIcon;
